import { Mail } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="relative py-12 bg-slate-950 border-t border-slate-800/50"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo & Company */}
          <div className="flex items-center gap-4">
            {/* Hexagon Logo SVG */}
            <svg
              width="36"
              height="42"
              viewBox="0 0 100 115"
              className="opacity-80"
            >
              <path
                d="M50 0 L93.3 25 L93.3 75 L50 100 L6.7 75 L6.7 25 Z"
                fill="none"
                stroke="#3b82f6"
                strokeWidth="3"
              />
              <path
                d="M50 15 L78.3 32.5 L78.3 67.5 L50 85 L21.7 67.5 L21.7 32.5 Z"
                fill="none"
                stroke="#3b82f6"
                strokeWidth="1.5"
                strokeOpacity="0.5"
              />
              <text
                x="50"
                y="60"
                textAnchor="middle"
                fill="#3b82f6"
                fontSize="32"
                fontWeight="bold"
                fontFamily="sans-serif"
              >
                1
              </text>
            </svg>
            <div>
              <p className="text-white font-bold">First Defense Compliance</p>
              <p className="text-slate-500 text-sm">
                Cybersecurity Excellence & CMMC Compliance
              </p>
            </div>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6">
            <a
              href="mailto:info@1dc.io"
              className="flex items-center gap-2 text-slate-400 hover:text-[#D4AF37] transition-colors text-sm"
              data-testid="footer-email-link"
            >
              <Mail className="w-4 h-4" />
              info@1dc.io
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 pt-8 border-t border-slate-800/50 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} First Defense Compliance. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-slate-600 text-xs">
              SDVOSB | Veteran-Owned
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
